import { ComboBox, type ComboBoxChangeEvent } from "@progress/kendo-react-dropdowns";
import type { BrandDto } from "../../../../contracts";

type BrandSelectorProps = {
    value: BrandDto | null;
    brands: BrandDto[];
    isFetching: boolean;
    disabled: boolean;
    onChange: (brandId: number | null) => void;
};

const BrandSelector: React.FC<BrandSelectorProps> = ({
    value,
    brands,
    isFetching,
    disabled,
    onChange
}: BrandSelectorProps) => {
    return (
        <div className="col-12">
            <label className="form-label small fw-semibold">
                Brand
            </label>
            <ComboBox
                data={brands}
                dataItemKey="id"
                textField="name"
                value={value}
                placeholder={isFetching ? "Loading brands..." : "Select brand"}
                disabled={disabled || isFetching}
                clearButton={true}
                style={{ width: "100%" }}
                onChange={(event: ComboBoxChangeEvent): void => {
                    const data: BrandDto | null = event.value;
                    onChange(data?.id ?? null);
                }}
            />
        </div>
    );
};

export default BrandSelector;
